/*
 * Submits the header's language and country forms as soon as a choice is made,
 * so the chips behave like the rest of the storefront's switchers instead of
 * needing a separate confirm button.
 *
 * Bound on the document rather than on the selects themselves: the theme
 * editor re-renders the header section in place, which would drop listeners
 * attached to the old markup.
 */
document.addEventListener('change', (event) => {
  const select = event.target.closest?.('.circles-localization__select');

  if (select && select.form) {
    select.form.submit();
  }
});
